import { useLockBodyScroll } from '@uidotdev/usehooks';
import React, { useEffect } from 'react';
import styles from './ZombiePurgeModal.module.scss';
import ZombiePurgeModalDashedLine from 'src/icons/ZombiePurgeModalDashedLine';
import { ActionButton } from 'src/ui/components';
import CrossIcon from 'src/icons/Cross';
import gsap from 'gsap';

export default function ZombiePurgeModal({ className, onModalClose, addressHasApprovedLootMintContract, onApproveClick, onPurgeClick, numberOfZombiesSelected, otherAddress, isOtherAddressSimilarToConnectedAddress }) {
	const [modalStepNumber, setModalStepNumber] = React.useState( 1 );

	// locking body scroll
	useLockBodyScroll();

	useEffect( () => {
		if ( addressHasApprovedLootMintContract === true ) {
			setModalStepNumber( 2 );
		}
	}, [addressHasApprovedLootMintContract]);


	const steps = [
		{
			header: 'Step 1',
			subHeader: 'Approve Contract',
		},
		{
			header: 'Step 2',
			subHeader: 'Purge Zombies',
		},
	];

	const isPlural = numberOfZombiesSelected > 1;
	const pluralSuffix = isPlural ? 's' : '';

	const modalContentVariations = {
		1: {
			header: 'Confirm contract',
			paragraph: 'You must approve the Apepe Loot contract to operate Zombies, to proceed with the Zombie Purge!',
			button: {
				text: 'Approve',
				onClick: onApproveClick,
			},
		},
		2: {
			header: 'Confirm PURGE',
			paragraph: `You are about to purge ${numberOfZombiesSelected} ${( otherAddress && !isOtherAddressSimilarToConnectedAddress ) && `to this address ${otherAddress}`} Zombie${pluralSuffix} in return for ${numberOfZombiesSelected} ${isPlural ? 'copies' : 'copy'} of 'The End of the War'.`,
			button: {
				text: 'Purge',
				onClick: onPurgeClick,
			},
		},
	};

	useEffect( () => {
		gsap.to( window, {
			duration: .5,

			scrollTo: { y: 'zombie-purge-modal' },
		});
	}, []);

	return (
		<div
			className={`relative flex flex-col ${className}`}>
			<div className='fixed top-0 left-0 bg-black opacity-50 w-screen h-screen' />
			<div id="zombie-purge-modal"
				className={`flex flex-col items-center fixed left-1/2 h-auto text-center rounded-lg box-border pt-9 pb-9 pl-8 pr-8 bg-black top-[7.5%] w-[422px] z-[3] ${styles['zombie-purge-modal']}`}>
				<CrossIcon onClick={onModalClose}
					className='absolute cursor-pointer right-[5%] top-[5%]' />
				<div className={`relative flex items-center justify-between w-full  max-w-[278px] ${styles['zombie-purge-modal-steps']}`}>
					<div className={`absolute left-1/2 top-[5%] z-[1] max-[310px]:w-[100px] max-[310px]:overflow-x-hidden ${styles['zombie-purge-modal-steps-divider']}`}><ZombiePurgeModalDashedLine /></div>
					{steps.map( ( step, index ) => {
						return <div key={index}
							className={`-f-family-burbank flex flex-col items-center z-[3] ${styles['zombie-purge-modal-steps-item']}`}>
							<div className={`relative bg-cover bg-center w-9 h-9  mb-3 font-bold rounded-full text-2xl leading-none bg-black ${styles['zombie-purge-modal-steps-item-number']}`}
								style={modalStepNumber > index + 1 ? { backgroundImage: 'url(/images/ZombiePurge/ModalCheckIcon.png)' } : {}}>
								{modalStepNumber <= index + 1 && <span className="absolute left-1/2 top-1/2">{index + 1}</span>}
							</div>
							<div className='text-xs uppercase leading-1'>{step?.header}</div>
							<div className='text-xs uppercase leading-1'>{step?.subHeader}</div>
						</div>;
					})}
				</div>
				<div>
					<h2 className={`m-0 p-0 uppercase mt-9 text-4xl leading-normal ${styles['zombie-purge-modal-header']}`}>{modalContentVariations[modalStepNumber]?.header}</h2>
					<p className={`m-0 p-0 text-center  flex-wrap uppercase w-[95%] font-normal mb-4 mt-4 text-sm leading-relaxed	  ${styles['zombie-purge-modal-paragraph']}`}>{modalContentVariations[modalStepNumber]?.paragraph}</p>
					<ActionButton className="w-full"
						onClick={modalContentVariations[modalStepNumber]?.button.onClick}
						textContent={modalContentVariations[modalStepNumber]?.button.text} />
				</div>

			</div>
		</div>
	);
}
